var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllusBdpEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 104,
    viewBox: "0 0 200 104",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#2175D9",
    cx: 64,
    cy: 64,
    r: 40
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "none",
    transform: "translate(40 40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8 50c1.21 0 2.2.964 2.2 2.143v25.714C86 79.036 85.01 80 83.8 80H44.2c-1.21 0-2.2-.964-2.2-2.143V52.143c0-1.179.99-2.143 2.2-2.143zm-.811 5.105a2 2 0 00-2.684-.893L63.6 62.578l-16.704-8.366-.214-.092a2 2 0 00-1.577 3.669L63.6 67.053l18.496-9.264.203-.117a2 2 0 00.69-2.567z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjEwNCIgdmlld0JveD0iMCAwIDIwMCAxMDQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxjaXJjbGUgZmlsbD0iIzIxNzVEOSIgY3g9IjY0IiBjeT0iNjQiIHI9IjQwIi8+CiAgICAgICAgPGcgZmlsbD0iI0ZGRiI+CiAgICAgICAgICAgIDxjaXJjbGUgY3g9IjI0IiBjeT0iMjQiIHI9IjI0IiBzdHJva2U9Im5vbmUiIGZpbGw9Im5vbmUiIGZpbGwtb3BhY2l0eT0iMCIgc3Ryb2tlLW9wYWNpdHk9IjAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQwIDQwKSIvPgogICAgICAgICAgICA8cGF0aCBkPSJNODMuOCA1MGMxLjIxIDAgMi4yLjk2NCAyLjIgMi4xNDN2MjUuNzE0Qzg2IDc5LjAzNiA4NS4wMSA4MCA4My44IDgwSDQ0LjJjLTEuMjEgMC0yLjItLjk2NC0yLjItMi4xNDNWNTIuMTQzYzAtMS4xNzkuOTktMi4xNDMgMi4yLTIuMTQzem0tLjgxMSA1LjEwNWEyIDIgMCAwIDAtMi42ODQtLjg5M0w2My42IDYyLjU3OGwtMTYuNzA0LTguMzY2LS4yMTQtLjA5MmEyIDIgMCAwIDAtMS41NzcgMy42NjlMNjMuNiA2Ny4wNTNsMTguNDk2LTkuMjY0LjIwMy0uMTE3YTIgMiAwIDAgMCAuNjktMi41Njd6Ii8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgIllusBdpEmail as ReactComponent };